module.exports = __webpack_public_path__ + "img/Zsuzsi_Simon_Alexandru_01.24e6e620.jpg";